export default __webpack_public_path__ + "static/media/Gbemi.3e580fa1.jpg";